/**
 * @desc 新增发货需求
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.DemandOrderExcelImportDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
